// extracted by mini-css-extract-plugin
export default {"PropertiesCount":"SubscriptionHome_PropertiesCount__xWvXg"};